import GhostContentAPI from "@tryghost/content-api";

(async () => {
  const blog = document.querySelector("footer.kw-footer .kw-footer--blog");
  const blogList = blog?.querySelector(".kw-footer--blog-ul");
  const template = document.getElementById("post-card-template");

  if (!blog || !blogList || !template) {
    console.log("not found blog or template element");
    return;
  }

  const config = {
    url: `${template?.dataset?.host}`,
    key: template?.dataset?.apikey,
    version: "v5.0",
  };

  if (!config.key || !config.url || !config.version) {
    console.log("blog-config invalid");
    return;
  }
  const api = new GhostContentAPI(config);

  api.posts
    .browse({ limit: 3, fields: ["title", "url"], order: "created_at DESC" })
    .then((posts) => {
      window.requestAnimationFrame(() => {
        blogList.textContent = "";
        posts.forEach((post) => {
          const li = document.createElement("li");
          const a = document.createElement("a");
          a.href = post.url;
          a.textContent = post.title;
          blogList.appendChild(li).appendChild(a);
        });
        if (posts.length) {
          blog.classList.remove("empty");
        }
      });
    })
    .catch((err) => {
      console.log("blog api", err);
    });
})();
